
<template>
    <Layout class="main">
        <Sider ref="siderRef" hide-trigger collapsible :collapsed-width="0"  v-model="isCollapsed" >
            <Menu active-name="1-2" theme="dark" width="auto" accordion :class="menuitemClasses" style="margin-top: 100px;">
                <MenuSub :menus="menuList" ></MenuSub>
            </Menu>
        </Sider>

        <Layout style="height: 100%; z-index: 3; ">
            <Header class="header-con">
                <div style="display: flex;align-items: center; justify-content: space-between;">
                    <div style="display: flex; align-items: center;">
                        <Icon @click="collapsedSider" :class="rotateIcon" type="md-menu" size="24"/>
                        <p style="margin-left: 25px;font-size: 15px; font-weight: bold;">黑牛货运</p>
                    </div>
                    <Infos :userName="userName" :avatarUrl="avaURL" :countMsg="countMessage" @event="userInfoEvent"></Infos>
                </div>
            </Header>
            <Layout>
                <Breadcrumb style="margin: 15px 15px">
					<!--
                    <BreadcrumbItem>Home</BreadcrumbItem>
                    <BreadcrumbItem>Components</BreadcrumbItem>
                    <BreadcrumbItem>Layout</BreadcrumbItem>
					-->
                    <BreadcrumbItem v-for="(item, index) in breadcrumbItems" :key="index">
                        <router-link v-if="item.path" :to="item.path">{{ item.title }}</router-link>
                        <span v-else>{{ item.title }}</span>
                    </BreadcrumbItem>
                </Breadcrumb>
                <Content class="content-wrapper">
                    <router-view v-slot="{Component}">
                        <KeepAlive>
                            <component :is="Component" :key="$route.name" v-if="$route.meta.isCache"/>
                        </KeepAlive>
                        <component :is="Component" :key="$route.name" v-if="!$route.meta.isCache"/>
                    </router-view>
                </Content>
            </Layout>

        </Layout>
    </Layout>
	<Modal title="修改密码" v-model="modPwDlgShow" @on-cancel="modPwDlgCancel" >
		<Form ref="dlgFromRef" :model="modPWData" :rules="modPWRule">
			<FormItem label="原密码" prop="oldPassword">
				<Input type="password" v-model="modPWData.oldPassword"/>
			</FormItem>
			<FormItem label="新密码" prop="newPassword">
				<Input type="password" v-model="modPWData.newPassword"/>
			</FormItem>
			<FormItem label="重复密码" prop="rePassword">
				<Input type="password" v-model="modPWData.rePassword"/>
			</FormItem>
		</Form>
		
		<template #footer>
			<Button type="primary" @click="modPwDlgOK">修改</Button>
		</template>
		
	</Modal>


</template>

<script setup>

import './main.less'

import { computed,ref,onMounted, reactive,watch } from "vue";
import { useStore} from 'vuex'
import { reqModifyPWSelf } from '@/api'
import MenuSub from '@c/MenuNav/MenuSub.vue'
import {useRoute, useRouter} from 'vue-router'
import routerMaps from '@/router/routerMaps'

import {setToken} from '@/utils/auth'
import Infos from './main-components/infos'
import { Modal,Input, Breadcrumb } from 'view-ui-plus'
import sha256 from 'sha256'
//import path from 'path';

//import SideMenu from "./components/side-menu"
const router=useRouter()
const route=useRoute()
const store=useStore();

const isCollapsed=ref(false)

const modPwDlgShow=ref(false)

//const menuList = ref([])

const menuList=computed(()=>{
	const userInfo= store.getters.UserInfo
	//console.log("menulist is update!!===============")
	if(!userInfo)
		return []
	return routerMaps.filter(item=>{
		if(!item.meta || !item.meta.roles)
			return true
			
		if(item.meta.roles.includes(userInfo.roleName))
			return true
		
		return false
	})
})

//const menuList = ref([])
const siderRef=ref(null)

const userName=ref("test")
const avaURL=ref('')
const countMessage=ref(0)

const breadcrumbItems = computed(() => {
    const items = [];
    // 添加首页
    items.push({ title: '登录', path: '/' });
    
    // 解析当前路由的matched数组
    if (route.matched && route.matched.length > 0) {
        // 跳过第一个路由（通常是根路由）
        for (let i = 1; i < route.matched.length; i++) {
            const matchedRoute = route.matched[i];
            if (matchedRoute.meta && matchedRoute.meta.title) {
                items.push({
                    title: matchedRoute.meta.title,
                    path: matchedRoute.path
                });
            }
        }
    }
    return items;
});

//=================================================================
onMounted(()=>{
    let routes= router.getRoutes()
    let fpath= route.meta.title
    //console.log(JSON.stringify(fpath))

    //console.log(store.getters.UserInfo)
    userName.value=store.getters.UserInfo?.nickName
    avaURL.value=store.getters.UserInfo?.headImageUrl
	
	//let r = router.getRoutes();
	//console.log("routes:"+ JSON.stringify(r));
	//console.log(menuList)
})


//=================================================================
const rotateIcon=computed(()=>{
    return [
        'menu-icon',
        isCollapsed.value?'rotate-icon':''
    ];
})

const menuitemClasses=computed(()=>{
    return [
        'menu-item',
        isCollapsed.value?'collapsed-menu':''
    ];
})

const  collapsedSider = () => {
    siderRef.value.toggleCollapse()
}
//=====================================================================
function userInfoEvent(param)
{
    console.log(param)
    if(param.EventName=="exit")
    {
        store.commit('setUser',null)
        setToken(null)
        router.push('login')
    }
	if(param.EventName === "mod_pw")
	{
		modPwDlgShow.value=true
		/*
		Modal.confirm({
			title:"test"
		})
		*/
	}
	if(param.EventName=="band_wx")
	{
		Modal.confirm({
			title:"绑定微信"
		})
	}
}

let modPWData=ref({
	oldPassword:'',
	newPassword:'',
	rePassword:''
})

let dlgFromRef=ref(null)

let modPWRule = reactive({
	oldPassword:[
		{type:'string',required:true,message:'不能为空',trigger:'blur'},
		],
	newPassword:[
		{type:'string',required:true,message:'不能为空',trigger:'blur'},
		{min:6,message:'密码最小6位'}
		],
	rePassword:[
		{type:'string',required:true,message:'不能为空',trigger:'blur'},
		{
			validator:(rule,value,callback)=>{
				if(value!=modPWData.value.newPassword)
					callback(new Error('密码不一致'))
				else
					callback()
			},trigger:'change'
		}
	]
})

function modPwDlgOK()
{
	//console.log("ok")
	dlgFromRef.value.validate((valid)=>{
		//console.log(valid)
		if(valid)
		{
			var oldPW = sha256(modPWData.value.oldPassword).toString();
			var newPW = sha256(modPWData.value.newPassword).toString();
			reqModifyPWSelf({type:0,oldPassword:oldPW,newPassword:newPW})
			.then(res=>{
				Modal.confirm({
					title:res.success?"修改成功":"修改失败"+res.message
				})
				
				if(res.success)
				{
					store.commit('setUser',null)
					setToken(null)
					router.push('login')
				}
				
			})
			.catch(err=>{
				
			})
			.finally(()=>{
				dlgFromRef.value.resetFields()
				modPwDlgShow.value=false
			})
			
		}
		else{
			
		}
	})
	
}

function modPwDlgCancel()
{
	//console.log("cancel")
	dlgFromRef.value.resetFields()
}



</script>

<style lang="less" scoped>

.menu-icon{
    transition: all .3s;
}
.rotate-icon{
    transform: rotate(-90deg);
}
</style>
